import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

// Minimal styled markdown renderer used for meeting notes and similar
// user-authored prose. Escapes HTML by default (react-markdown safety),
// supports GFM (tables, task lists, strikethrough, autolinks).
const components = {
  h1: (p) => <h1 className="text-base font-bold text-gray-900 mt-3 mb-2" {...p} />,
  h2: (p) => <h2 className="text-sm font-bold text-gray-900 mt-3 mb-2" {...p} />,
  h3: (p) => <h3 className="text-sm font-semibold text-gray-900 mt-2 mb-1" {...p} />,
  p:  (p) => <p className="text-sm text-gray-700 leading-relaxed mb-2 last:mb-0" {...p} />,
  ul: (p) => <ul className="list-disc list-outside pl-5 text-sm text-gray-700 space-y-1 mb-2" {...p} />,
  ol: (p) => <ol className="list-decimal list-outside pl-5 text-sm text-gray-700 space-y-1 mb-2" {...p} />,
  li: (p) => <li className="leading-relaxed" {...p} />,
  a:  (p) => <a className="text-blue-600 hover:underline" target="_blank" rel="noreferrer" {...p} />,
  strong: (p) => <strong className="font-semibold text-gray-900" {...p} />,
  em: (p) => <em className="italic" {...p} />,
  blockquote: (p) => <blockquote className="border-l-2 border-gray-200 pl-3 text-gray-500 italic my-2" {...p} />,
  code: ({ inline, className, children, ...rest }) => (
    inline
      ? <code className="bg-gray-100 text-gray-800 px-1 py-0.5 rounded text-[12px] font-mono" {...rest}>{children}</code>
      : <code className={`block bg-gray-50 border border-gray-200 rounded-md p-3 text-[12px] font-mono text-gray-800 overflow-x-auto ${className || ''}`} {...rest}>{children}</code>
  ),
  pre: (p) => <pre className="my-2" {...p} />,
  hr: () => <hr className="my-3 border-gray-200" />,
  table: (p) => <div className="overflow-x-auto my-2"><table className="text-sm border-collapse" {...p} /></div>,
  th: (p) => <th className="border border-gray-200 bg-gray-50 px-2 py-1 text-left text-xs font-semibold text-gray-700" {...p} />,
  td: (p) => <td className="border border-gray-200 px-2 py-1 text-sm text-gray-700" {...p} />,
}

export default function Markdown({ children, className = '' }) {
  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children || ''}
      </ReactMarkdown>
    </div>
  )
}
